import QueryParamsUtils from '../../shared/helpers/query-params-utils';

interface LessonPageQueryParams {
  courseId: number;
  unitId?: number;
  levelName?: string;
  unitName?: string;
  isFromUnitIndex? : boolean;
}

export class LessonPageParams {
  private params: LessonPageQueryParams;

  constructor(searchParams: string) {
    this.params = QueryParamsUtils.getQueryParamsFromHash<LessonPageQueryParams>(searchParams);
  }

  public get courseId(): number {
    return +this.params.courseId;
  }

  public get unitId(): number {
    return +this.params.unitId;
  }

  public get unitName(): string {
    return this.params.unitName;
  }

  public get levelName(): string {
    return this.params.levelName;
  }

  public get isFromUnitIndex(): boolean {
    return this.params.isFromUnitIndex;
  }
}



// WEBPACK FOOTER //
// ./ts/app/learning/lesson-page/lesson-page-params.ts